const manageGroundStation = {
  manageGroundStation: {
    pageTitle: '지상국 관리',
    description: '등록된 지상국을 조회하고 이용할 수 있습니다.',
    searchPlaceholder: '검색',
    addButton: '추가',
    viewDetailsButton: '상세 보기'
  }
};

export default manageGroundStation;